export default "__VITE_ASSET__CR8r6zD8__"